// Suggafoot's — Instagram feed (Graph API grid + post embeds)

(function () {
  function loadEmbedScript() {
    if (window.instgrm) {
      window.instgrm.Embeds.process();
      return;
    }
    if (document.querySelector('script[data-sf-instagram-embed]')) return;
    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.instagram.com/embed.js';
    script.setAttribute('data-sf-instagram-embed', 'true');
    script.onload = function () {
      if (window.instgrm) window.instgrm.Embeds.process();
    };
    document.body.appendChild(script);
  }

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text || '';
    return div.innerHTML;
  }

  function truncateCaption(text, max) {
    if (!text) return '';
    var clean = text.replace(/\s+/g, ' ').trim();
    if (clean.length <= max) return clean;
    return clean.slice(0, max - 1) + '…';
  }

  function renderApiGrid(feed, items) {
    var grid = feed.querySelector('[data-sf-ig-grid]');
    if (!grid) return;
    grid.innerHTML = '';
    items.forEach(function (item) {
      var link = document.createElement('a');
      link.className = 'sf-ig-feed__tile';
      link.href = item.permalink || '#';
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.setAttribute('aria-label', truncateCaption(item.caption, 80) || 'Instagram post');

      var img = document.createElement('img');
      img.loading = 'lazy';
      img.decoding = 'async';
      img.alt = truncateCaption(item.caption, 120) || 'Instagram post';
      img.src = item.thumbnail_url || item.media_url || '';
      link.appendChild(img);

      if (item.media_type === 'VIDEO' || item.media_type === 'REELS') {
        var badge = document.createElement('span');
        badge.className = 'sf-ig-feed__tile-badge';
        badge.textContent = item.media_type === 'REELS' ? 'Reel' : 'Video';
        link.appendChild(badge);
      }

      grid.appendChild(link);
    });
    feed.hidden = false;
  }

  function showApiError(feed, message) {
    var status = feed.querySelector('[data-sf-ig-status]');
    if (status) {
      status.textContent = message;
      status.hidden = false;
    }
    feed.hidden = false;
  }

  function fetchApiFeed(feed) {
    var token = feed.dataset.sfIgToken;
    var userId = feed.dataset.sfIgUserId;
    var limit = parseInt(feed.dataset.sfIgLimit || '6', 10);
    if (!token || !userId) return;

    var fields = 'id,caption,media_type,media_url,thumbnail_url,permalink';
    var url =
      'https://graph.instagram.com/' +
      encodeURIComponent(userId) +
      '/media?fields=' +
      encodeURIComponent(fields) +
      '&limit=' +
      limit +
      '&access_token=' +
      encodeURIComponent(token);

    fetch(url)
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.error && data.error.message ? data.error.message : 'Could not load Instagram feed');
          return data;
        });
      })
      .then(function (data) {
        var items = (data && data.data) || [];
        if (!items.length) {
          showApiError(feed, 'No Instagram posts found. Check your account ID and token.');
          return;
        }
        renderApiGrid(feed, items);
      })
      .catch(function (err) {
        showApiError(feed, err.message || 'Instagram feed unavailable. Check Theme settings.');
      });
  }

  document.querySelectorAll('[data-sf-instagram-feed]').forEach(function (feed) {
    var mode = feed.dataset.sfIgMode;
    if (mode === 'api') {
      fetchApiFeed(feed);
    }
    if (mode === 'posts') {
      loadEmbedScript();
    }
  });
})();
